import { PurchaseInvoice } from '../types/purchase';
import axiosInstance from './Instance/axiosInstance';

export const getPurchases = async (): Promise<PurchaseInvoice[]> => {
    const response = await axiosInstance.get('/purchases');
    return response.data;
};

export const createPurchase = async (data: Omit<PurchaseInvoice, 'id'>): Promise<PurchaseInvoice> => {
    const response = await axiosInstance.post('/purchases', data);
    return response.data;
};

export const updatePurchaseApi = async (id: string, data: Omit<PurchaseInvoice, 'id'>): Promise<PurchaseInvoice> => {
    const response = await axiosInstance.put(`/purchases/${id}`, data);
    return response.data;
};

export const deletePurchaseApi = async (id: string): Promise<void> => {
    await axiosInstance.delete(`/purchases/${id}`);
};
